(function () {
  if (window.clCardQuantityReady) return;
  window.clCardQuantityReady = true;

  function normalize(input) {
    var minimum = Number(input.min) || 1;
    var maximum = input.max ? Number(input.max) : Infinity;
    var value = Number.parseInt(input.value, 10);

    if (!Number.isFinite(value)) value = minimum;
    input.value = Math.min(maximum, Math.max(minimum, value));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cl-quantity-minus], [data-cl-quantity-plus]');
    if (!button) return;

    var selector = button.closest('[data-cl-card-quantity]');
    if (!selector) return;

    var input = selector.querySelector('.cl-card-quantity__input');
    if (!input) return;

    normalize(input);

    var minimum = Number(input.min) || 1;
    var maximum = input.max ? Number(input.max) : Infinity;
    var step = Number(input.step) || 1;
    var current = Number(input.value) || minimum;
    var next = button.hasAttribute('data-cl-quantity-plus')
      ? current + step
      : current - step;

    input.value = Math.min(maximum, Math.max(minimum, next));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.cl-card-quantity__input')) return;
    normalize(event.target);
  });
})();
